/**
 * Check if an object is undefined or empty
 * @param obj Object to test
 * @returns obj is undefined or empty
 */
const isObjectUndefinedOrEmpty = (obj: Record<string, unknown> | undefined) => !obj || Object.keys(obj).length === 0;

export default isObjectUndefinedOrEmpty;
